const $ = jQuery.noConflict();

'use strict';
const Tabs = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domTabsBlockWrap: $('.js-checkout-form__payment-tabs'),
	$domTabsBlockBox: $('.js-checkout-form__payment-tab-box'),
	$domTabsBlockBtn: $('.js-checkout-form__payment-tab-nav-btn'),
	classActive: 'is-active',
	classStop: 'stay',
	classFixed: 'fixed',

	/** @description Initialize */
	init: function() {
		this.tabsTabsBlock();
	},

	tabsTabsBlock: function() {
		Tabs.$domTabsBlockBtn.on('click', function(e) {
			e.preventDefault();
			$(this).siblings(Tabs.$domTabsBlockBtn).removeClass(Tabs.classActive);
			$(this).addClass(Tabs.classActive);
			const index = $(this).index();
			$(this).parent().parent().parent().find(Tabs.$domTabsBlockBox).hide();
			$(this).parent().parent().parent().children().find(Tabs.$domTabsBlockBox).eq(index).fadeIn('slow');
			if (window.innerWidth < 768) {
				$('html, body').animate({
					scrollTop: Tabs.$domTabsBlockWrap.offset().top -150
				}, 1000);
			}
		});
	},
};

export default Tabs;
